import { type AxiosError } from 'axios'
import { type QueryObserverOptions } from 'react-query'

import { useGetServices } from 'queries/services/use-get-services'
import { type PagedUserDefinedServicesResponse } from 'types/api/services/service'
import { ms } from 'utils/time/millisecond'

const PAGE_SIZE = 1
const STALE_TIME = ms.seconds(30)

export function useHasServices(
  options: Omit<
    QueryObserverOptions<PagedUserDefinedServicesResponse, AxiosError>,
    'staleTime' | 'queryKey' | 'queryFn'
  > = { enabled: true }
) {
  const {
    data: services,
    isError: isServicesError,
    isFetching: isServicesLoading
  } = useGetServices(PAGE_SIZE, {
    ...options,
    staleTime: STALE_TIME
  })
  return {
    hasServices: services?.items ? services.items.length > 0 : false,
    isServicesError,
    isServicesLoading
  }
}
